import React from 'react';

const HEIGHT = '122px';

const StickyBar = ({ children }) => {
  React.useEffect(() => {
    // const [footer] = document.getElementsByTagName('footer');
    // const placeholder = document.createElement('div');
    // placeholder.style.marginBottom = HEIGHT;
    // footer.appendChild(placeholder);
    // return () => {
    //   placeholder.remove();
    // };
  }, []);

  return <div className="sticky-bar">{children}</div>;
};

export default StickyBar;
